require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./reducing-criminal-activities-at-rental-properties.json") })
        }
      }, "path---reducing-criminal-activities-at-rental-properties");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---reducing-criminal-activities-at-rental-properties!./.cache/json/reducing-criminal-activities-at-rental-properties.json
// module id = 969
// module chunks = 231608221292675